import { Api } from "../api";

export const loginApi = async (body: { email: string; password: string }) => {
  const response = await Api.post(`/user/signin`, body, {});

  return response.data;
};

export const emailCheckApi = async (email: string) => {
  const response = await Api.post(
    "/user/email-checking",
    { email, scope_type: "individual" },
    {}
  );

  return response.data;
};

export const signUpApi = async (body: {
  email: string;
  password: string;
  user_type: string;
  scope_type: string;
  first_name?: string;
  last_name?: string;
  phone?: string;
  country_code?: string;
}) => {
  const response = await Api.post("/user/sign-up/mobile", body, {});

  return response.data;
};

export const sendEmailOtpApi = async (email: string, token: string) => {
  const response = await Api.post(
    "/user/send-email-verification-code",
    { email },
    { headers: { "x-access-token": token } }
  );

  return response.data;
};

export const resendEmailOtpApi = async (email: string, token: string) => {
  const response = await Api.post(
    "/user/re-send-email-verification-code",
    { email },
    { headers: { "x-access-token": token } }
  );

  return response.data;
};

export const verifyOtpApi = async (
  body: { email: string; otp: string },
  token: string
) => {
  const response = await Api.post("/user/verify-email-otp", body, {
    headers: { "x-access-token": token },
  });

  return response.data;
};
